var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.751 1.25h3.067l-6.7 7.413L20 18.75h-6.172l-4.833-6.118-5.531 6.118H.394l7.167-7.929L0 1.25h6.328l4.37 5.592L15.75 1.25zm-1.076 15.723h1.7L5.404 2.933H3.58l11.094 14.04z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48cGF0aCBkPSJNMTUuNzUxMTcwNCwwIEwxOC44MTc5NjY5LDAgTDEyLjExNzkyNTIsNy40MTI4MjA1MSBMMjAsMTcuNSBMMTMuODI4Mzk2NiwxNy41IEw4Ljk5NDU3NjU1LDExLjM4MjE3OTUgTDMuNDYzNTg4NzUsMTcuNSBMMC4zOTQ5MzgxMTcsMTcuNSBMNy41NjEzMDM0OCw5LjU3MTE1Mzg1IEwwLDAgTDYuMzI4MjgwNzIsMCBMMTAuNjk3NjMxMyw1LjU5MTkyMzA4IEwxNS43NTExNzA0LDAgWiBNMTQuNjc0ODI1LDE1LjcyMzA3NjkgTDE2LjM3NDE3MTQsMTUuNzIzMDc2OSBMNS40MDQ5MDQyOCwxLjY4MzU4OTc0IEwzLjU4MTMyODUxLDEuNjgzNTg5NzQgTDE0LjY3NDgyNSwxNS43MjMwNzY5IFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMS4yNSkiLz48L3N2Zz4=";
export { SvgTwitter as ReactComponent };